const getCityData = state => state?.report?.cityData
const getTierData = state => state?.report?.tierData
const getCollegeData = state => state?.report?.collegeData
const getRoleData = state => state?.report?.roleData
const getRoundData = state => state?.report?.roundData
const getDegreeData = state => state?.report?.degreeData
const getCourseTypeData = state => state?.report?.courseTypeData
const getRolesPublishedData = state => state?.report?.rolesPublishedData
const getCandidateApplicationStatus = state =>
  state?.report?.candidateApplicationStatus
const excelData = state => state?.report?.excelData
const getApplicationDriveLevel = state => state?.report?.applicationDriveLevel
const getHiringLevelData = state => state?.report?.hiringLevelData
const getInterviewData = state => state?.report?.interviewData
const getResumeData = state => state?.report?.studentDetails
const getStatusData = state => state?.report?.studentStatus
const selectors = {
  getCityData,
  getTierData,
  getRolesPublishedData,
  excelData,
  getCandidateApplicationStatus,
  getCollegeData,
  getRoleData,
  getApplicationDriveLevel,
  getRoundData,
  getCourseTypeData,
  getDegreeData,
  getHiringLevelData,
  getInterviewData,
  getResumeData,
  getStatusData,
}
export default selectors
